<template>
    <div class="regionpick" @click.stop>
        <input type="text" class="input-text" v-model="fullName" readonly placeholder="点击选择地区" @click="openCity();" :style="'width:' + width"/>
        <div class="province" v-if="selectShow" ref="province"  :style="right ? 'right:0' : 'left:0'">
            <div class="hd clearfix">
                <a class="back fr" v-if="backShow" href="javascript:void(0);" @click="cityBack();">上一级</a>
                <span class="tit" v-if="levels == '3'">{{provinceName}}/{{cityName}}/{{countryName}}</span>
                <span class="tit" v-if="levels == '2'">{{provinceName}}/{{cityName}}</span>
                <span class="tit" v-if="levels == '1'">{{provinceName}}</span>
            </div>
            <ul class="city-list clearfix">
                <li v-for="(i,index) in arr" :key="index" @click="clickCityName(i,index);">{{i.name}}</li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: "citys",
    props: {
        levels: {//控制层级
            type: String,
            default: '3',
        },
        isHasWorld:{
            type:Boolean,
            default:function(){
                return false;
            },
        },
        isAutoWidth:{
            type:Boolean,
            default:function(){
                return false;
            },
        },
    },
    data() {
        return {
            allArr:[],
            right:false,
            selectShow:false,
            arr:[],
            prevArr:[],
            backShow:false,//控制返回按钮显示
            provinceName:'选择省份',//省份名称
            fullProvinceName:'选择省份',//省份全称
            cityName:'选择城市',
            fullCityName:'选择城市',
            countryName:'选择区县',
            fullCity:'',
            fullName:'',
            fanName:'',
            zxsType:1,
            curType:1,
            width:'auto'
        }
    },
    mounted() {
        document.addEventListener('click', this.closeCity)
        this.fullName = this.curFullName;
    },
    destroyed () {
        document.removeEventListener('click', this.closeCity)
    },
    created() {
        let that = this;
		that.$axios.get(that.$mapOssMapUrl + '/citys.json').then((res) => {
            that.allArr = res.data.arrCity;
            if(that.isHasWorld){
                let tmp ={
                    "name": "国际",
                    "fullname": "国际","sub": [{"name": "全市"}],
                    "type": 0
                }
                that.allArr.push(tmp)
            }
        })
    },
    methods: {
        //关闭
        closeCity () {
            if (this.selectShow) {
                this.selectShow = false;
            }
        },
        // 打开城市
        openCity () {
            let that = this;
            if(that.selectShow == true){
                that.selectShow = false;
            }else{
                that.selectShow = true;
                that.backShow = false;
                that.provinceName = '选择省份';
                that.cityName = '选择城市';
                //that.arr = that.allArr.shortProvince;
                that.arr = that.allArr;
                that.prevArr = that.allArr;
                that.$nextTick(() =>{
					let left = that.$refs.province.getBoundingClientRect().left;
					let widowW = document.body.clientWidth;
					let width = that.$refs.province.offsetWidth;
					if(widowW - left < width){
						that.right = true;
					}
				})
            }
        },
        //点击市
        // clickCityName (name,index) {
        //     let that = this;
        //     let provinceName = '';
        //     let fullProvinceName = '';
        //     let cityName = that.cityName;
        //     if(that.provinceName === '选择省份'){//点击的是省份fullCity
        //         that.provinceName = name;
        //         that.fullProvinceName = that.allArr.province[index];
        //         if(that.levels === '1' || name === '全国' || name === '国际'){//只选择省份
        //             that.fanName = that.provinceName;
        //             that.fullName = that.provinceName;
        //             that.selectShow = false;
        //             that.callBack();
        //             that.provinceName = '选择省份';
        //             return;
        //         }
        //         that.backShow = true;
        //         that.arr = that.allArr.city[index-1];
        //         that.fullCity = that.allArr.fullCity[index-1];
        //     }else if(cityName === '选择城市'){//点击的是城市
        //         that.cityName = name;
        //         let names = that.fullCity[index];
        //         that.fullCityName = names;
        //         //that.fullName = that.fullProvinceName + '-' + name;
        //         that.fullName = that.provinceName + '-' + name;
        //         that.fanName = that.provinceName + '-' + names;
        //         that.selectShow = false;
        //             that.callBack();
        //             that.provinceName = '选择省份';
        //             that.cityName = '选择城市';
        //             return;
        //     }
        // },
        clickCityName (item,index) {
            let that = this;
            // let provinceName = '';
            // let fullProvinceName = '';
            let cityName = that.cityName;
            let countryName = that.countryName;
            that.fullName = '';
            that.curType = 1;
            if(that.provinceName === '选择省份'){//点击的是省份fullCity
                that.provinceName = item.name;
                that.fullProvinceName = item.fullname;
                that.zxsType = item.type;
                if(that.levels === '1' || item.name === '全国' || item.name === '国际'){//只选择省份
                    that.fanName = that.provinceName;
                    that.fullName = that.fullProvinceName;
                    that.selectShow = false;
                    that.fullCityName = '';
                    that.callBack();
                    that.provinceName = '选择省份';
                    that.cityName = '选择城市';
                    that.countryName = '选择区县';
                    return;
                }
                that.backShow = true;
                that.prevArr = that.arr;
                that.arr = item.sub;
            }else if(cityName === '选择城市'){//点击的是城市
                that.cityName = item.name;
                if(that.zxsType == 2){
                    that.fullCityName = '';
                    if(item.fullname==undefined ){
                        that.countryName = item.name
                    }else{
                        that.countryName = item.fullname
                    }
                    that.fullName = that.fullProvinceName + '-' + that.countryName;
                }else{
                    that.fullCityName = (item.name =='全省')?item.name:item.fullname;
                    that.fullName = that.fullProvinceName + '-' + that.fullCityName;
                }
                that.fanName = that.provinceName + '-' + that.fullCityName;
                let iszxs = 1;
                if(item.sub != undefined){
                    if(item.sub.length<=0){iszxs = 2;}
                };
                if(that.levels === '2' || item.name === '全省' || that.zxsType == 2 ||iszxs == 2){
                    if(iszxs == 2){
                        that.curType = 5;
                    }
                    that.selectShow = false;
                    that.callBack();
                    // that.provinceName = '选择省份';
                    that.cityName = '选择城市';
                    that.countryName = '选择区县';
                    return;
                }
                that.backShow = true;
                that.prevArr = that.arr;
                that.arr = item.sub;
            }else if(countryName==="选择区县"){
                that.countryName = item.name;
                that.fullName = that.fullProvinceName + '-' + that.fullCityName + '-' + item.name;
                that.selectShow = false;
                that.callBack();
                // that.provinceName = '选择省份';
                // that.cityName = '选择城市';
                 that.countryName = '选择区县';
            }
        },
        // 返回
        cityBack () {
            let that = this;
            if(that.allArr == that.prevArr){
                that.backShow = false;
                that.provinceName = '选择省份';
                that.arr = that.prevArr;
            }else{
                that.cityName = '选择城市';
                that.arr = that.prevArr;
                that.prevArr = that.allArr
            }
        },
        callBack () {
            let that = this,type = 1;
            if(that.isAutoWidth){
                that.width = that.fullName.length *15+30+'px';
            }else{
                that.width = 'auto'
            }
            if(that.curType == 5){
                type = that.curType ;
            }else{
                type = that.zxsType
            }
            that.$emit('cityCallback',[this.fullProvinceName,this.fullCityName,this.cityName,this.provinceName,this.countryName,type]);
        }
	}
}
</script>
<style lang="" scoped>
    .regionpick{display:inline-block;position:relative;}
    .regionpick:before{content:'';width:14px;height:14px;position:absolute;top:9px;right:9px;background:url(../../static/images/icons.png) no-repeat 0 -165px;}
    .regionpick .input-text{min-width:150px;width:206px;height:32px;padding-right: 30px;}
    .province{position:absolute;top:35px;width:462px;background:#fff;border:1px solid #ddd;z-index:9;box-shadow:0 0 15px rgba(0,0,0,.2);}
    .province .hd{padding:0 15px;line-height:32px;position:relative;border-bottom:1px solid #ddd}
    .province .hd .back{color:#31bcf6;}
    .province .city-list{padding:10px;}
    .province .city-list li{float:left;min-width:110px;padding:5px;line-height:24px;cursor:pointer;}
    .province .city-list li:hover{color:#0095eb;}
</style>



// WEBPACK FOOTER //
// src/components/citys.vue